import { Injectable } from '@angular/core';

export interface Toast {
  id?: string;
  title: string;
  message: string;
  status: 'pending' | 'success' | 'error' | 'loading';
  autohide: boolean;
  progress?: number;
  taskid?: string;
  durationMs?: number;
}


@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts: Toast[] = [];

  private defaultSuccessDurationMs = 2500; // garde ton comportement actuel
  private defaultImageDurationMs = 5000;

  private pushToast(toast: Toast) {
    this.toasts.push(toast);

    if (toast.autohide) {
      const duration = toast.durationMs ?? this.defaultSuccessDurationMs;
      setTimeout(() => this.remove(toast), duration);
    }
  }

  success(title: string, message: string, durationMs?: number) {
    this.pushToast({ title, message, status: 'success', autohide: true, durationMs });
  }

  successOnce(id: string, title: string, message: string, durationMs?: number) {
    this.removeById(id);
    this.pushToast({ id, title, message, status: 'success', autohide: true, durationMs });
  }

  error(title: string, message: string, autohide: boolean = false) {
    this.pushToast({ title, message, status: 'error', autohide });
  }

  loading(title: string, message: string = ''): Toast {
    const toast: Toast = {
      id: `loading-${Date.now()}`,
      title,
      message,
      status: 'loading',
      autohide: false,
    };
    this.toasts.push(toast);
    return toast;
  }

  createProgress(id: string, title: string, message: string) {
    const existingToast = this.toasts.find(toast => toast.id === id);
    if (!existingToast) {
      this.toasts.push({ id, title, message, status: 'pending', autohide: false, progress: 0 });
    }
  }

  updateProgress(id: string, message: string, progress: number) {
    const toast = this.toasts.find((toast) => toast.id === id);
    if (toast) {
      toast.message = message;
      toast.progress = progress;
      toast.status = progress === 100 ? 'success' : 'pending';
    }
  }

  cancelProgress(id: string, message: string) {
    this.toasts = this.toasts.map((toast) =>
      toast.id === id ? { ...toast, message, status: 'error' } : toast
    );
  }

  hideLoading(toast: Toast) {
    this.remove(toast);
  }

  remove(toast: Toast) {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }

  removeById(id: string) {
    this.toasts = this.toasts.filter((toast) => toast.id !== id);
  }

  clear() {
    this.toasts.splice(0, this.toasts.length);
  }



  imageSelected(url: string, taskId: string) {
    const title = 'Merveilleux choix !';
    const toastMessage = `Nous ajoutons cette image à votre email<br><img src="${url}" alt="Votre choix">`;

    this.pushToast({
      title,
      message: toastMessage,
      status: 'success',
      autohide: true,
      durationMs: this.defaultImageDurationMs,
    });
  }
}

